import "./webchat.scss";

import {FComponent} from "@Common/react/f-component";

interface P {
    next: (value) => JSX.Element;
    containerEl: string;
    config: {
        customerId,
        skill,
        isInternalUser,
        addressStreet,
        addressCity,
        addressPostalCode,
        addressState,
        phoneNumber,
        customField1Label,
        customField1,
        customField2Label,
        customField2,
        chatEnabled,
    };
}
interface S {
    active: boolean;
    autoJoined: boolean;
    started: boolean;
}

export class WebchatIntegration extends FComponent<P,S> {
    webchat;

    constructor(props, context) {
        super(props, context);

        this.state = {
            autoJoined: false,
            active: false,
            started: false,
        };

        this.onMount(() => {

            // Required if reconnects are enabled
            // @ts-ignore
            window.PURECLOUD_WEBCHAT_FRAME_CONFIG = {
                containerEl: props.containerEl,
            };

            const {config} = this.props;
            const chatStartedFromWordpress = !!document.cookie.split(";").find(x => x.trim().startsWith("xd_chat_interacted=1"));
            this.initChat(config.skill, !chatStartedFromWordpress && !config.isInternalUser);
        });
    }

    initChat = (skill, reconnectEnabled) => {
        // @ts-ignore
        window.ININ && window.ININ.webchat.create(getChatConfig(skill, reconnectEnabled))
            .then((webchat) => {
                this.webchat = webchat;

                // Optionally use isAutoJoined if reconnects are enabled
                if (webchat.isAutoJoined()) {
                    // Do something to disable chat button
                    this.setState({
                        autoJoined: true,
                    });
                }

                webchat.chatStarted = () => {
                    // delete the wordpress chat interacted cookie if set - this will enable chat reconnects on subsequent pages
                    if (!!document.cookie.split(";").find(x => x.trim().startsWith("xd_chat_interacted=1"))) {
                        document.cookie = "xd_chat_interacted=; expires=" + (new Date()) + "; path=/";
                    }
                    this.setState({active: true});
                };

                webchat.chatEnded = () => {
                    this.setState({active: false});
                };
            })
            .catch(err => {
                console.log("err", err);
            })
        ;
    };

    render() {
        const {next, containerEl} = this.props;
        const {autoJoined, started, active} = this.state;

        return next({
            autoJoined,
            active,
            started,
            startChat: (config) => {

                if (!this.webchat) {
                    return;
                }

                const chatStartedFromWordpress = !!document.cookie.split(";").find(x => x.trim().startsWith("xd_chat_interacted=1"));
                this.initChat(config.skill, !chatStartedFromWordpress && !config.isInternalUser);

                this.setState({started: true});

                //Use the updateConfig function to update batches of properties by passing in a partially filled chatConfig object
                this.webchat.getConfig().setData({
                    firstName: config.firstName,
                    lastName: config.lastName,

                    customerId: config.customerId,
                    addressStreet: config.addressStreet,
                    addressCity: config.addressCity,
                    addressPostalCode: config.addressPostalCode,
                    addressState: config.addressState,
                    phoneNumber: config.phoneNumber,
                    customField1Label: config.customField1Label,
                    customField1: config.customField1,
                    customField2Label: config.customField2Label,
                    customField2: config.customField2,
                    customField3Label: "URL",
                    customField3 : window.location.href,
                    chatEnabled: config.chatEnabled,
                });

                // Alternatively, call webchat.renderPopup here. Note that reconnects do not apply to popup chat.
                try{
                    this.webchat.renderFrame({
                        containerEl
                    });
                }
                catch(err){
                    console.log("err", err);
                    alert('Webchat could not be loaded at this time.')
                }
            },
            close: () => {

                clearDom(document.getElementById(containerEl));
                this.setState({started: false, autoJoined: false});
            },
        });
    }
}

const getChatConfig = (skill, reconnectEnabled = true) => ({
    webchatAppUrl: "https://apps.mypurecloud.com/webchat",
    webchatServiceUrl: "https://realtime.mypurecloud.com:443",
    orgId: 17328,
    orgName: "xpressdocs",

    skills: ( window.location.hostname == "www.xpressdocs.com" ? [skill] : ["Web Chat Test"] ),

    queueName: ( window.location.hostname == "www.xpressdocs.com" ? "Web Chat" : "Web Chat Test" ),
    logLevel: "DEBUG",
    locale: "en",
    reconnectEnabled,
    reconnectOrigins: [ 'https://www.xpressdocs.com', 'https://www.xpressdocs.com' ],
    companyLogo: {
        width: 300,
        height: 64,
        url: "https://assets.xpressdocs.com/next_images/xadmin/logos/xd-logo.png"
    },
    companyLogoSmall: {
        width: 150,
        height: 32,
        url: "https://assets.xpressdocs.com/next_images/xadmin/logos/xd-logo.png"
    },
    agentAvatar: {
        width: 462,
        height: 462,
        url: "https://d3a63qt71m2kua.cloudfront.net/developer-tools/917/assets/images/agent.jpg"
    },
    welcomeMessage: "Thank you for choosing Xpressdocs! A Client Services Representative will be with you momentarily.",
    cssClass: "webchat-frame",
    css: {
        width: "100%",
        height: "90%"
    },
    offlineSchedules: [{
        day: "Saturday,Sunday",
        city: "America/Chicago"
    }],
    onlineSchedules: [{
        day: "Monday-Friday",
        time: "800-1800",
        city: "America/Chicago"
    }],
    chatNowElement: 'chat-button',
});

const clearDom = (node) => {
    while (node.lastChild) {
        node.removeChild(node.lastChild);
    }
};
